import { momentToDateTime } from '@marine/utils';
import { UpdateFileMutationVariables } from 'services';

export const transformFileUpdate = (values: any) => {
  const expirationDate = values?.expiration_date ? momentToDateTime(values?.expiration_date) + ':00' : null;
  const hasExpirationReminder = !!values?.expiration_date_time_unit && !!values?.expiration_date_time_unit_type;

  const expirationDateTimeUnit = !!expirationDate ? values?.expiration_date_time_unit : null;

  const data: UpdateFileMutationVariables = {
    id: values.id,
    name: values?.name,
    filename: values?.filename,
    issuance_date: values?.issuance_date ? momentToDateTime(values?.issuance_date) + ':00' : undefined,
    issued_by: values?.issued_by,
    boat_detail_id: values?.boat_detail_id || null,
    expiration_date: expirationDate,
    expiration_date_time_unit: expirationDateTimeUnit,
    expiration_date_time_unit_type: expirationDateTimeUnit ? values?.expiration_date_time_unit_type : null,
    has_expiration_date_reminder: hasExpirationReminder,
    notes: values?.notes,
    folder_id: values.folder_id,
  };

  return data;
};
